import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import useLocale from 'js/hooks/useLocale'
import {
  languages,
  translatedLanguageNames,
  language,
} from 'js/locale/constants'
import { linkClasses } from './Header'
import Chevron from 'media/chevron.svg?svgr-webpack'
import Check from './check.svg?svgr-webpack'

const LanguageSwitcher = ({ inverted, isStuck }) => {
  const { language: currentLanguage, setLanguage } = useLocale()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div
      className={cn(
        'relative z-40 text-left lg:text-inherit',
        inverted && !isStuck ? 'text-inherit' : 'text-BrandDark',
      )}
    >
      {menuOpen && (
        <div
          className="fixed left-0 top-0 h-full w-full"
          onClick={() => setMenuOpen(false)}
        />
      )}
      <button
        className={cn(linkClasses, 'relative uppercase')}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-controls="locale-dropdown"
        data-testid="language-list-toggler"
        data-uid="language-list-toggler"
        type="button"
      >
        <span className="sr-only">Language: </span>
        <span className="flex">
          {currentLanguage}
          <Chevron
            className={cn(
              'relative my-auto ml-6 transform',
              menuOpen && 'rotate-180',
              'bottom-[1px] h-[5px] w-[8px]',
            )}
          />
        </span>
      </button>
      <div id="locale-dropdown">
        {menuOpen && (
          <div
            className={cn(
              'absolute right-0 top-full lg:left-0 lg:right-auto',
              '-ml-12 mt-8 py-12',
              'rounded-8 bg-white shadow-elevated',
            )}
          >
            <ul>
              {languages.map((code) => (
                <li key={code} lang={code} data-testid="language-list">
                  <a
                    href={code === language.ENGLISH ? '/' : `/${code}`}
                    className={cn(
                      'relative block',
                      'py-6 pl-24 pr-80',
                      'transition hover:bg-grey-superlight',
                      currentLanguage === code
                        ? 'type-small-fat text-BrandDark'
                        : 'type-small text-Type',
                    )}
                    onClick={(e) => {
                      e.preventDefault()
                      setLanguage(code)
                      setMenuOpen(false)
                    }}
                    data-uid="language-list-toggler-language"
                  >
                    {currentLanguage === code && (
                      <Check className="absolute right-0 mr-24 origin-right scale-50 transform lg:scale-2/3" />
                    )}
                    <span>{translatedLanguageNames[code]}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

LanguageSwitcher.propTypes = {
  inverted: PropTypes.bool,
  isStuck: PropTypes.bool,
}

export default LanguageSwitcher
